import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { LogService } from '../../shared/log/log.service';
import { AweHttpService } from './awe.http.service';
import { AweResponse } from '../models/awe-response';
import { AweRequest } from '../models/awe-request';

@Injectable()
export class AweStore {

  constructor(private aweHttpService: AweHttpService,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService) {
  }

  getAweApprovers(eventId: number, eventPartyId): Observable<Array<String>> {
    return this.aweHttpService.getAweApprovers(eventId, eventPartyId)
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_AWE_APPROVERS'));
        this.logService.error(`Error fetching AWE approvers: ${error}`);
        return Observable.throw(error);
      })
      .map((result: Array<String>) => {
        return result;
      });
  }

  startWorkflow(aweRequest: AweRequest): Observable<AweResponse> {
    return this.aweHttpService.executeAweWorkflow(aweRequest)
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.START_AWE_WORKFLOW'));
        this.logService.error(`Error starting AWE workflow: ${error}`);
        return Observable.throw(error);
      })
      .map((result: AweResponse) => {
        this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
        return result;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/awe.store.ts